
import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import AdminLayout from '@/pages/admin/AdminLayout';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminBookings from '@/pages/admin/AdminBookings';
import AdminPayments from '@/pages/admin/AdminPayments';
import AdminFinancialDashboard from '@/pages/admin/AdminFinancialDashboard';
import AdminPractitioners from '@/pages/admin/users/AdminPractitioners';
import AdminClients from '@/pages/admin/users/AdminClients';
import AdminCategories from '@/pages/admin/cms/AdminCategories';
import AdminPosts from '@/pages/admin/cms/AdminPosts';
import AdminPostForm from '@/pages/admin/cms/AdminPostForm';
import AdminTags from '@/pages/admin/cms/AdminTags';
import AdminTherapyModalities from '@/pages/admin/cms/AdminTherapyModalities';
import TherapyAnalytics from '@/pages/admin/cms/TherapyAnalytics';
import AdminImages from '@/pages/admin/cms/AdminImages';
import AdminSupportTickets from '@/pages/admin/support/AdminSupportTickets';
import AdminTicketDetail from '@/pages/admin/support/AdminTicketDetail';
import UserBehaviorAnalysis from '@/pages/admin/data/UserBehaviorAnalysis';
import AdminFeaturedPractitioners from '@/pages/admin/cms/AdminFeaturedPractitioners';
import AdminNutrientDatabase from '@/pages/admin/cms/AdminNutrientDatabase';

import AdminEmailCampaigns from '@/pages/admin/emails/AdminEmailCampaigns';
import AdminEmailTemplates from '@/pages/admin/emails/AdminEmailTemplates';
import AdminEmailLogs from '@/pages/admin/emails/AdminEmailLogs';
import AdminEmailStats from '@/pages/admin/emails/AdminEmailStats';
import AdminEmailOverview from '@/pages/admin/emails/AdminEmailOverview';
import AdminMonitoring from '@/pages/admin/AdminMonitoring';
import AdminNotesTemplates from '@/pages/admin/cms/AdminNotesTemplates';
import AdminNotesTemplateForm from '@/pages/admin/cms/AdminNotesTemplateForm';
import PartnerOrganizationsAdmin from '@/pages/admin/cms/PartnerOrganizationsAdmin';
import AdminVersionInfo from '@/pages/admin/AdminVersionInfo';
import AdminManagementPage from '@/pages/admin/AdminManagementPage';
import JobManagement from '@/components/admin/JobManagement';
import AdminReferralStats from '@/pages/admin/AdminReferralStats';
import AdminAIUsage from '@/pages/admin/AdminAIUsage';
import AdminDataManagement from '@/pages/admin/AdminDataManagement';

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout><Outlet /></AdminLayout>}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="admin-management" element={<AdminManagementPage />} />
        <Route path="bookings" element={<AdminBookings />} />
        <Route path="payments" element={<AdminPayments />} />
        <Route path="finances" element={<AdminFinancialDashboard />} />
        <Route path="users">
          <Route path="practitioners" element={<AdminPractitioners />} />
          <Route path="clients" element={<AdminClients />} />
        </Route>
        <Route path="cms">
          <Route path="categories" element={<AdminCategories />} />
          <Route path="posts" element={<AdminPosts />} />
          <Route path="posts/new" element={<AdminPostForm />} />
          <Route path="posts/edit/:id" element={<AdminPostForm />} />
          <Route path="tags" element={<AdminTags />} />
          <Route path="therapy-modalities" element={<AdminTherapyModalities />} />
          <Route path="therapy-analytics" element={<TherapyAnalytics />} />
          <Route path="images" element={<AdminImages />} />
          <Route path="notes-templates" element={<AdminNotesTemplates />} />
          <Route path="notes-templates/new" element={<AdminNotesTemplateForm />} />
          <Route path="notes-templates/edit/:id" element={<AdminNotesTemplateForm />} />
          <Route path="featured-practitioners" element={<AdminFeaturedPractitioners />} />
          <Route path="partner-organizations" element={<PartnerOrganizationsAdmin />} />
          <Route path="nutrient-database" element={<AdminNutrientDatabase />} />
        </Route>
        <Route path="support">
          <Route index element={<AdminSupportTickets />} />
          <Route path="tickets/:id" element={<AdminTicketDetail />} />
        </Route>
        <Route path="user-analytics" element={<UserBehaviorAnalysis />} />
        <Route path="referral-stats" element={<AdminReferralStats />} />
        <Route path="ai-usage" element={<AdminAIUsage />} />
        <Route path="emails">
          <Route index element={<AdminEmailOverview />} />
          <Route path="campaigns" element={<AdminEmailCampaigns />} />
          <Route path="templates" element={<AdminEmailTemplates />} />
          <Route path="logs" element={<AdminEmailLogs />} />
          <Route path="analytics" element={<AdminEmailStats />} />
        </Route>
        <Route path="jobs" element={<JobManagement />} />
        <Route path="data-management" element={<AdminDataManagement />} />
        <Route path="monitoring" element={<AdminMonitoring />} />
        <Route path="version" element={<AdminVersionInfo />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
